<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="loading">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="sending_email">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Sending, please wait
        </div>
      </div>
    </div>
    <div class="box-content">
      <div class="flex-sm mb-3 justify-between">
          <div class="pr-1-sm pb-1 pb-0-sm mr-auto flex flex-col justify-around">
              <div class="flex flex-col txt-sm">
                  <span class="txt-positive"><i class="fal fa-check"></i> Account activated</span>
                  <span class="txt-warning"><i class="fal fa-user-clock"></i> Temporary Account</span>
                  <span class="txt-positive"><i class="fal fa-envelope-open-text"></i> Lead Recipient</span>
              </div>
          </div>
          <div class="flex-xs justify-end">
              <div class="pr-1-xs pb-1 pb-0-xs" v-if="!show_deleted_users">
                <div class="multi-select-input" @click.stop="with_selected_dropdown_open = !with_selected_dropdown_open" style="min-width: 200px;">
                  <div class="multi-select-input-placeholder">
                    With Selected...
                    <div class="dropdown-icon">
                      <i class="fal fa-chevron-down"></i>
                    </div>
                  </div>
                  <div class="multi-select-input-inner" v-show="with_selected_dropdown_open">
                    <div class="multi-select-input-group">
                      <div @click="massResendActivationEmail" class="txt-primary txt-sm">Resend Activation Emails</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pr-1-xs pb-1 pb-0-xs">
                  <a class="btn-primary" href="/add-customer" v-if="from_section === 'customers'">
                      Add New
                  </a>
                  <a class="btn-primary" :href="`/company/${company_id}/add-user`" v-if="from_section === 'companies'">
                      Add New
                  </a>
              </div>
              <div class="pr-1-xs pb-1 pb-0-xs">
                <a class="btn-primary" @click="exportCustomers">
                  Export
                </a>
              </div>
              <div class="pr-1-xs pb-1 pb-0-xs" v-show="from_section === 'customers'">
                <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open" style="min-width:165px; max-width: 400px;">
                  <div class="multi-select-input-placeholder">
                    Filter...
                    <div class="dropdown-icon">
                      <i class="fal fa-chevron-down"></i>
                    </div>
                  </div>
                  <div class="multi-select-input-inner" v-show="filter_dropdown_open">
                    <div class="multi-select-input-group">
                      <h1 class="input-group-title">Company Types</h1>
                      <div class="checkboxes">
                        <div class="checkbox level-1" v-for="company_type in all_company_types">
                          <label>
                            <input type="checkbox" name="selected_company_types" :value="company_type.id" v-model="selected_company_types">
                            <span class="checkbox-label">{{ company_type.label }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="multi-select-input-group mt-3">
                      <h1 class="input-group-title">System Types</h1>
                      <div class="checkboxes">
                        <div class="checkbox level-1" v-for="system_type in all_epwin_system_types">
                          <label>
                            <input type="checkbox" name="selected_system_types" :value="system_type.id" v-model="selected_system_types">
                            <span class="checkbox-label">{{ system_type.label }}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="multi-select-input-group mt-3">
                      <h1 class="input-group-title">Deleted Users</h1>
                      <div class="checkboxes">
                        <div class="checkbox level-1">
                          <label>
                            <input type="checkbox" name="show_deleted_users" :value="'deleted'" v-model="show_deleted_users">
                            <span class="checkbox-label">Show Deleted Users</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="multi-select-input-group mt-3">
                      <h1 class="input-group-title">Activation</h1>
                      <div class="checkboxes">
                        <div class="checkbox level-1">
                          <label>
                            <input type="checkbox" name="selected_activation_values" :value="true" v-model="selected_activation_values">
                            <span class="checkbox-label">Activated</span>
                          </label>
                        </div>
                        <div class="checkbox level-1">
                          <label>
                            <input type="checkbox" name="selected_activation_values" :value="false" v-model="selected_activation_values">
                            <span class="checkbox-label">Not Activated</span>
                          </label>
                        </div>
                      </div>
                    </div>
                      <div class="multi-select-input-group mt-3">
                          <h1 class="input-group-title">ACP</h1>
                          <div class="checkboxes">
                              <div class="checkbox level-1">
                                  <label>
                                      <input type="checkbox" name="selected_acp_values" :value="true" v-model="selected_acp_values">
                                      <span class="checkbox-label">Yes</span>
                                  </label>
                              </div>
                              <div class="checkbox level-1">
                                  <label>
                                      <input type="checkbox" name="selected_acp_values" :value="false" v-model="selected_acp_values">
                                      <span class="checkbox-label">No</span>
                                  </label>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
              <div>
                  <input type="text" placeholder="Search" class="form-control" v-model="search_query">
              </div>
          </div>
      </div>
      <template v-if="!loading && total_count > 0">
        <div class="alert-success align-center mb-3">
          {{ selected_customers.length }} user<span v-if="selected_customers.length !== 1">s</span> selected.
          <span class="txt-primary cursor-pointer" @click="selectAllUsers">Select all {{ total_count }} users.</span>
          <span class="cursor-pointer txt-danger" @click="selected_customers = [], select_all_on_page_active = false">Clear selection.</span>
        </div>
        <div class="relative">
          <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8;" v-show="filtering"></div>
          <table class="table_list">
            <thead>
            <tr>
              <th class="checkbox">
                <input type="checkbox" name="select_all_on_page_active" v-model="select_all_on_page_active">
              </th>
              <th class="cursor-pointer">
                <div class="flex relative">
                  <div v-if="activated_date_sort_by === 'desc'" style="font-style: italic;" @click="activated_date_sort_by = 'asc'">
                    Activation Date <i class="fal fa-chevron-down"></i>
                  </div>
                  <div v-if="activated_date_sort_by === 'asc'" style="font-style: italic;" @click="activated_date_sort_by = 'none'">
                    Activation Date <i class="fal fa-chevron-up"></i>
                  </div>
                  <div v-if="activated_date_sort_by === 'none'" @click="activated_date_sort_by = 'desc'">
                    Activation Date
                  </div>
                  <div class="_control" @click.stop="activated_date_filter_open = !activated_date_filter_open">
                    <i class="fal fa-filter"></i>
                  </div>
                  <div class="box p-3" v-show="activated_date_filter_open"
                       style="
                              position: absolute;
                              top: 30px;
                              right: 0;
                              width: 185px;
                          ">
                    <div class="align-right" @click="activated_date_filter_open = false">
                      <i class="fal fa-times"></i>
                    </div>
                    <div class="mt-2" @click.stop>
                      <div class="input-group">
                        <div class="input-group-addon" style="width: 60px;">From:</div>
                        <datepicker input-class="form-control" v-model="date_filter_start"></datepicker>
                      </div>
                      <div class="input-group mt-1">
                        <div class="input-group-addon" style="width: 60px;">To:</div>
                        <datepicker input-class="form-control" v-model="date_filter_end"></datepicker>
                      </div>
                    </div>
                    <div class="mt-1 txt-danger align-right" @click="date_filter_start = null, date_filter_end = new Date()">
                      <i class="fal fa-times"></i> Clear
                    </div>
                  </div>
                </div>
              </th>
              <th v-show="from_section === 'customers'">Company Name</th>
              <th v-show="from_section === 'customers'">Company Type</th>
              <th>User Name</th>
              <th>Email</th>
              <th v-show="from_section === 'companies'">Phone</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(customer, index) in users">
              <td class="checkbox">
                <input type="checkbox" name="selected_customers" v-model="selected_customers" :value="customer.id">
              </td>
              <td>
                {{ customer.formatted_activated_date }}
              </td>
              <td v-show="from_section === 'customers'">
                <span class="txt-warning" v-if="customer.temporary_login"><i class="fal fa-user-clock"></i></span>
                <span class="txt-positive" v-if="customer.hasLoggedIn"><i class="fal fa-check"></i></span>
                {{ customer.company.name }}
              </td>
              <td v-show="from_section === 'customers'">{{ customer.company.company_type.label }}</td>
              <td>
                <span class="txt-warning" v-if="customer.temporary_login && from_section !== 'customers'"><i class="fal fa-user-clock"></i></span>
                <span class="txt-positive" v-if="customer.hasLoggedIn && from_section !== 'customers'"><i class="fal fa-check"></i></span>
                <span class="txt-positive" v-if="customer.lead_recipient && from_section !== 'customers'"><i class="fal fa-envelope-open-text"></i></span>
                {{ customer.name }}
              </td>
              <td style="word-break: break-all;">
                {{ customer.email }}
              </td>
              <td v-show="from_section === 'companies'">{{ customer.phone }}</td>
              <td class="td_view">
                <a :href='"/manage-customer/"+customer.id' class="txt-primary" v-if="customer.deleted_at === null">
                  <i class="fa fa-eye"></i>
                </a>
              </td>
              <td class="td_more-options">
                <a class="txt-primary" @click="toggleMoreOptionsDropdown(customer.id)">
                  ...
                </a>
                <div v-show="more_options_dropdown_open_for === customer.id" class="td_more-options-dropdown-wrapper">
                  <template v-if="customer.deleted_at === null">
                    <a @click="exportCompanyFull(customer)">
                      <i class="fa fa-envelope txt-primary"></i> Export Company
                    </a>
                    <a @click="sendAccountActivationReminderEmail(customer.id)" v-if="customer.hasLoggedIn">
                      <i class="fa fa-envelope txt-primary"></i> Send Reminder Email
                    </a>
                    <a @click="resendActivationEmail(customer.id)" v-if="!customer.hasLoggedIn">
                      <i class="fa fa-envelope txt-primary"></i> Resend Activation Email
                    </a>
                    <a @click="deleteCustomer(customer.id)">
                      <i class="fa fa-trash txt-danger"></i> Delete Customer
                    </a>
                  </template>
                  <template v-else>
                    <a @click="restoreCustomer(customer.id)">
                      <i class="fa fa-trash-undo txt-primary"></i> Restore Customer
                    </a>
                  </template>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <template>
          <div class="pagination-bar wrapper mb-3 mt-3">
            <div class="row">
              <div class="col">
                <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                    class="fa fa-caret-left"></i></a>
                <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                   class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
              </div>
              <div class="col align-right">
                <div class="mt-1 mb-1">
                  {{ total_count }} results found
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <template v-if="!loading && total_count === 0">
        <strong>
          No Results Found
        </strong>
      </template>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";

export default {
  mounted() {
    if(window.location.hash) {
      this.current_page = window.location.hash.substring(1);
    }
    this.loadUsers();
  },
  props: [
      'from_section',
      'company_id',
      'all_company_types',
      'all_epwin_system_types',
  ],
  components: {
    'datepicker': Datepicker,
  },
  data() {
    return {
      users: [],
      search_query: '',
      current_page: 1,
      selected_company_types: [],
      selected_system_types: [],
      total_count: 0,
      total_pages: 0,
      limit: 20,
      loading: true,
      show_deleted_users: false,
      deleting: false,
      filter_dropdown_open: false,
      filtering: false,
      selected_activation_values: [],
      selected_acp_values: [],
      activated_date_sort_by: 'none',
      date_filter_type: 'activated_date',
      date_filter_start: null,
      date_filter_end: new Date(),
      activated_date_filter_open: false,
      sending_email: false,
      more_options_dropdown_open_for: null,
      selected_password_link: '',
      selected_customers: [],
      with_selected_dropdown_open: false,
      select_all_on_page_active: false,
    }
  },
  methods: {
    loadUsers: _.debounce(function () {
      axios.post('/getCustomers', {
        company_id: this.company_id,
        page_number: this.current_page,
        search_query: this.search_query,
        selected_company_types: this.selected_company_types,
        selected_system_types: this.selected_system_types,
        show_deleted_users: this.show_deleted_users,
        selected_activation_values: this.selected_activation_values,
        selected_acp_values: this.selected_acp_values,
        activated_date_sort_by: this.activated_date_sort_by,
        date_filter_type: this.date_filter_type,
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
        limit: this.limit,
      }).then((response) => {
        this.select_all_on_page_active = false;
        this.users = response.data.data;
        this.total_count = response.data.total;
        this.total_pages = response.data.last_page;
        this.loading = false;
        this.filtering = false;
      });
    }, 250),
    prevPage() {
      this.current_page = this.current_page - 1;
      this.setPageHash();
      this.loadUsers();
    },
    nextPage() {
      this.current_page = this.current_page + 1;
      this.setPageHash();
      this.loadUsers();
    },
    deleteCustomer(customer_id) {
      Swal.fire({
        title: 'Are you sure you want to remove this user?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post('/deleteCustomer', {
            customer_id: customer_id,
          }).then((response) => {
            this.current_page = 1;
            this.setPageHash();
            this.loadUsers();
            Swal.fire({
              title: 'User Deleted',
              icon: 'success',
            });
          });
        }
      });
    },
    restoreCustomer(customer_id) {
      Swal.fire({
        title: 'Are you sure you want to restore this user?',
        text: 'This will restore the user, their company if deleted, enquiries, case studies and installation showcase entries.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post('/restoreCustomer', {
            customer_id: customer_id,
          }).then((response) => {
            this.current_page = 1;
            this.setPageHash();
            this.loadUsers();
            Swal.fire({
              title: 'User Restored',
              icon: 'success',
            });
          });
        }
      });
    },
    setPageHash() {
      window.location = `#${this.current_page}`;
    },
    exportCompanyFull(customer) {
      axios({
        url: '/company/exportCompanyFull',
        method: 'POST',
        responseType: 'blob',
        data: {
          company_id: customer.company_id,
        },
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', customer.company.name+' Export.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
    exportCustomers() {
      axios({
        url: '/exportCustomers',
        method: 'POST',
        responseType: 'blob',
        data: {
          company_id: this.company_id,
          search_query: this.search_query,
          selected_company_types: this.selected_company_types,
          selected_system_types: this.selected_system_types,
          show_deleted_users: this.show_deleted_users,
          selected_activation_values: this.selected_activation_values,
          selected_acp_values: this.selected_acp_values,
          activated_date_sort_by: this.activated_date_sort_by,
          date_filter_type: this.date_filter_type,
          date_filter_start: this.date_filter_start,
          date_filter_end: this.date_filter_end,
        },
      }).then((response) => {
          Swal.fire({
              title: 'Export Started',
              icon: 'success',
              text: 'Once completed, the export will be sent to your email address.'
          });
      });
    },
    sendAccountActivationReminderEmail(customer_id) {
      this.sending_email = true;
      axios.post('/sendAccountActivationReminderEmail', {
        user_id: customer_id,
      }).then((response) => {
        this.sending_email = false;
        Swal.fire({
          title: 'Email Sent',
          icon: 'success',
        });
      });
    },
    resendActivationEmail(customer_id) {
      this.sending_email = true;
      axios.post('/resendActivationEmail', {
        user_id: customer_id,
      }).then((response) => {
        this.sending_email = false;
        Swal.fire({
          title: 'Email Sent',
          icon: 'success',
        });
      });
    },
    massResendActivationEmail() {
      this.sending_email = true;
      let amount_to_send = this.selected_customers.length;
      if (amount_to_send < 1) {
        this.sending_email = false;
        Swal.fire({
          title: 'Please select at least 1 customer',
          icon: 'error',
        });
      } else {
        this.selected_customers.forEach((user) => {
          axios.post('/resendActivationEmail', {
            user_id: user,
          }).then((response) => {
            amount_to_send = amount_to_send - 1;

            if(amount_to_send === 0) {
              this.sending_email = false;
              Swal.fire({
                title: 'Emails Sent',
                icon: 'success',
              });
            }
          });
        });
      }
    },
    toggleMoreOptionsDropdown(customer_id) {
      if (this.more_options_dropdown_open_for === customer_id) {
        this.more_options_dropdown_open_for = null;
      } else {
        this.more_options_dropdown_open_for = customer_id;
      }
    },
    selectAllUsers: _.debounce(function () {
      axios.post('/selectAllUsers', {
        company_id: this.company_id,
        search_query: this.search_query,
        selected_company_types: this.selected_company_types,
        selected_system_types: this.selected_system_types,
        show_deleted_users: this.show_deleted_users,
        selected_activation_values: this.selected_activation_values,
        selected_acp_values: this.selected_acp_values,
        activated_date_sort_by: this.activated_date_sort_by,
        date_filter_type: this.date_filter_type,
        date_filter_start: this.date_filter_start,
        date_filter_end: this.date_filter_end,
      }).then((response) => {
        response.data.forEach((user_id) => {
          if(this.selected_customers.indexOf(user_id) === -1) {
            this.selected_customers.push(user_id)
          }
        });
        this.loading = false;
        this.filtering = false;
      });
    }, 250),
  },
  watch: {
    search_query() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    selected_company_types() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    selected_system_types() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    show_deleted_users() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    selected_activation_values() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    selected_acp_values() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    activated_date_sort_by() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    date_filter_type() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    date_filter_start() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    date_filter_end() {
      this.filtering = true;
      this.current_page = 1;
      this.setPageHash();
      this.loadUsers();
    },
    select_all_on_page_active(newVal, oldVal) {
      if(newVal === true) {
        this.users.forEach((user) => {
          if(this.selected_customers.indexOf(user.id) === -1) {
            this.selected_customers.push(user.id)
          }
        });
      }
      if(newVal === false) {
        this.users.forEach((user) => {
          if(this.selected_customers.indexOf(user.id) !== -1) {
            this.selected_customers.splice(this.selected_customers.indexOf(user.id), 1);
          }
        });
      }
    },
  },
};
</script>
